import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import {
  TabHeader,
} from '../../atoms/CommonParts';
import {getNowPlayingTracks, getRoomTracks} from '../../../api';
import {useCustomDialog} from '../../../contexts/CustomDialogContext';
import moment from 'moment/moment';
import './style.scss';
import {PageMainTitle} from '../../atoms/CommonParts';

const ITEMS_PER_PAGE = 9;

const Page = styled.div`
`;

const TopDescription = styled.div`
  padding: 40px 0 20px;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  span {
    
    font-weight: bold;
    display: inline-block;

    a {
      margin-left: 3px;
      color: #000000;
      text-decoration: underline;
    }
  }
`;

const PlaylistsArea = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  margin-bottom: 60px;
  @media ${config.layout.wide} {
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 44px;
  }

`;

const PlaylistItemElm = styled.div`
  
  text-decoration: none;
  display: block;
  width: 100%;
  border-radius: 2px;
  border: 2px solid #000000;
  padding: 20px 20px 20px 20px;
  transform: none;
  @media ${config.layout.wide} {
    width: calc((100% - 40px) / 3);
  }
`;

const PlaylistItemDate = styled.div`
  margin-top: 3px;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  white-space: pre;
`;

const PlaylistRoomLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 18px;

  &:first-child {
    margin-top: 0;
  }
`;

const PlaylistRoom = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  margin-top: 5px;
  overflow-wrap: break-word;
`;

const PlaylistTrack = styled.div`
  margin-top: 3px;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  overflow-wrap: break-word;
`;

const PagerArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const NotFoundMessage = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
`;

function PlaylistItem({track}) {

  const trackStr = [track.title || '', track.artist || ''].filter(s => !!s).
      join(' / ') || '- - - - - - - - - -';

  return (
      <PlaylistItemElm>
        <PlaylistRoomLabel>Room / floor</PlaylistRoomLabel>
        <PlaylistRoom>{track.room.name || ''}</PlaylistRoom>
        <PlaylistRoomLabel>Date</PlaylistRoomLabel>
        <PlaylistItemDate>
          {
            track.played_ms ?
                moment(track.played_local_datetime).
                    format('YYYY/MM/DD HH:mm:ss') :
                '- - - - - - - - - -'
          }
        </PlaylistItemDate>
        <PlaylistRoomLabel>Track</PlaylistRoomLabel>
        <PlaylistTrack>{trackStr}</PlaylistTrack>
      </PlaylistItemElm>
  );
}

function PlaylistsPagenation({data, changePage}) {
  let pageCount = 0;
  if (data.total) {
    pageCount = Math.ceil(data.total / ITEMS_PER_PAGE);
  }
  let currentPage = data.page;
  if (pageCount < 2 || currentPage < 1 || pageCount < currentPage) {
    return '';
  }

  let hasPrev = currentPage > 1;
  let hasNext = currentPage < pageCount;

  let hasPrevDots = pageCount >= 4 && currentPage >= 3;
  let hasNextDots = pageCount >= 4 && currentPage <= pageCount - 2;
  let linkStartPage = Math.max(
      currentPage - (currentPage == pageCount ? 2 : 1),
      1,
  );
  let linkEndPage = Math.min(linkStartPage + 2, pageCount);

  return (
      <PagerArea className="pager-area">
        {hasPrev
            ? (() => {
              let params = new URLSearchParams({});
              params.set('page', currentPage - 1);
              return (
                  <div
                      className={`prev`}
                      onClick={() => {changePage(currentPage - 1);}}
                  ></div>
              );
            })()
            : ''}

        {hasPrevDots ? <div className="dots">…</div> : ''}
        {[...Array(linkEndPage - linkStartPage + 1)].map((_, i) => {
          let params = new URLSearchParams({});
          let p = i + linkStartPage;
          params.set('page', p);
          return (
              <div
                  key={i}
                  className={`number ${currentPage == p ? 'current' : ''}`}
                  onClick={() => {changePage(p);}}
              >{p}</div>
          );
        })}
        {hasNextDots ? <div className="dots">…</div> : ''}
        {hasNext
            ? (() => {
              let params = new URLSearchParams({});
              params.set('page', currentPage + 1);
              return (
                  <div
                      className={`next`}
                      onClick={() => {changePage(currentPage + 1);}}
                  ></div>
              );
            })()
            : ''}
      </PagerArea>
  );
}

export default function ReportingStatusNowPlayingPage() {
  const app = useApp();
  const navigate = useNavigate();
  const {errorDialogWithAPIError} = useCustomDialog();
  const [data, setData] = useState({
    loaded: false,
    tracks: [],
    allTracks: [],
    total: 0,
    page: 0,
  });

  const changePage = (newPage) => {
    let start = (newPage - 1) * ITEMS_PER_PAGE;
    let tracks = data.allTracks.slice(start, start + ITEMS_PER_PAGE);
    setData({
      ...data,
      tracks,
      page: newPage,
    });
  };

  useEffect(() => {
    let detached = false;
    app.showHeader();
    document.title = 'Reporting status';

    (async () => {
      if (detached) {
        return;
      }
      try {
        window.incrementLoading();
        let {tracks} = await getNowPlayingTracks();
        window.decrementLoading();
        //tracks = tracks.slice(0, 10);
        setData({
          loaded: true,
          allTracks: tracks,
          tracks: tracks.slice(0, ITEMS_PER_PAGE),
          total: tracks.length,
          page: 1,
        });
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        if (!detached) {
          await errorDialogWithAPIError(e);
          setData({
            loaded: true,
            tracks: [],
            allTracks: [],
            total: 0,
            page: 0,
          });
        }
      }
    })();

    return () => {
      detached = true;
    };
  }, []);

  return (
      <Page>
        <PageMainTitle><span>Reporting status</span></PageMainTitle>
        <TabHeader
            buttons={[
              {
                title: 'Now playing',
              },
              {
                title: 'Last track transmitted',
              },
            ]}
            selectedIndex={0}
            onClickTab={() => {
              navigate(`/reporting-status/rooms/`);
            }}
            style={{
              marginTop: 40,
            }}
        />
        <TopDescription>
          View the current tracks playing.
        </TopDescription>
        {
          data.loaded ? (
              data.tracks.length ? (
                  <>
                    <PlaylistsArea>
                      {data.tracks.map((track, i) => {
                        return (
                            <PlaylistItem key={i} track={track}/>
                        );
                      })}
                    </PlaylistsArea>
                    <PlaylistsPagenation data={data} changePage={changePage}/>
                  </>
              ) : <NotFoundMessage>No track to display.</NotFoundMessage>
          ) : ('')
        }
      </Page>
  );
}

export function ReportingStatusRoomTracksPage() {
  const app = useApp();
  const navigate = useNavigate();
  const {errorDialogWithAPIError} = useCustomDialog();
  const [data, setData] = useState({
    loaded: false,
    tracks: [],
    allTracks: [],
    total: 0,
    page: 0,
  });

  const changePage = (newPage) => {
    let start = (newPage - 1) * ITEMS_PER_PAGE;
    let tracks = data.allTracks.slice(start, start + ITEMS_PER_PAGE);
    setData({
      ...data,
      tracks,
      page: newPage,
    });
  };

  useEffect(() => {
    let detached = false;
    app.showHeader();
    document.title = 'Reporting status';

    (async () => {
      if (detached) {
        return;
      }
      try {
        window.incrementLoading();
        let {rooms} = await getRoomTracks();
        window.decrementLoading();
        setData({
          loaded: true,
          allTracks: rooms,
          tracks: rooms.slice(0, ITEMS_PER_PAGE),
          total: rooms.length,
          page: 1,
        });
      } catch (e) {
        window.decrementLoading();
        console.error(e);
        if (!detached) {
          await errorDialogWithAPIError(e);
          setData({
            loaded: true,
            tracks: [],
            allTracks: [],
            total: 0,
            page: 0,
          });
        }
      }
    })();

    return () => {
      detached = true;
    };
  }, []);

  return (
      <Page>
        <PageMainTitle><span>Reporting status</span></PageMainTitle>
        <TabHeader
            buttons={[
              {
                title: 'Now playing',
              },
              {
                title: 'Last track transmitted',
              },
            ]}
            selectedIndex={1}
            onClickTab={() => {
              navigate(`/reporting-status/`);
            }}
            style={{
              marginTop: 40,
            }}
        />
        <TopDescription>
          Refresh this page to see the latest tracks played.<br/>
          <span>Whatʼs the last track submitted? <a href={'/venue/q/139'}
                                                    target={'_blank'}>here</a></span>
        </TopDescription>
        {
          data.loaded ? (
              data.tracks.length ? (
                  <>
                    <PlaylistsArea>
                      {data.tracks.map((track, i) => {
                        return (
                            <PlaylistItem key={i} track={track}/>
                        );
                      })}
                    </PlaylistsArea>
                    <PlaylistsPagenation data={data} changePage={changePage}/>
                  </>
              ) : <NotFoundMessage>No room to display.</NotFoundMessage>
          ) : ('')
        }
      </Page>
  );

}